import Parse from 'parse'

// Sets up the Parse client.
export default function () {
  let parseAppId
  let parseServerUrl
  let parseJavaScriptKey

  switch (process.env.NODE_ENV) {
    case 'production':
      parseAppId = 'ypxi0xf7zxm2l7ifjzxazhfp0749q4lcbgxkg561'
      parseJavaScriptKey = '2p3jymp0gs5fnv6cmld5cizi67a0lckfpxlj957b'
      parseServerUrl = 'https://pg-app-u3wuxdfdd7lafbwkxdk4b05c69b7bp.scalabl.cloud/1/'
      break
    case 'staging':
      parseAppId = 'PzmD0oynGBBBD5Et8APGP2WplSh469BoQE8PjjMO'
      parseJavaScriptKey = 'lJVF7EsDvQQ1MeN0a3xHWEPPSzhojKOOW8Q4O9pl'
      parseServerUrl = 'https://pg-app-9g4s5s1eelmi0cedirwvi5etsz4e3s.scalabl.cloud/1/'
      break
    case 'development':
      parseAppId = 'ypxi0xf7zxm2l7ifjzxazhfp0749q4lcbgxkg561'
      parseServerUrl = 'http://localhost:1337/parse'
      break
  }

  Parse.initialize(parseAppId, parseJavaScriptKey)
  Parse.serverURL = parseServerUrl
  Parse.Object.enableSingleInstance()
}



// WEBPACK FOOTER //
// ./src/core/setup-parse.js